<template>
  <div>
    <div v-if="second > 0" class="result-loading-warp">
      <div>
        <img class="loading-img" src="@/assets/imgs/loading.gif" alt="" />
        <!-- <circle-progress v-model="percent" />
        <span>{{ secondFmt }}s</span> -->
      </div>
      <!-- <div class="result-loading-tips">
        {{ i18n.msg_tips_loading }}
      </div> -->
      <div class="loading-title">
        {{ i18n.loading_title }}
      </div>
      <div class="loading-tips">
        {{ i18n.loading_tips }}
      </div>
    </div>
    <div v-else-if="order" class="result-content">
      <h2>{{ i18n.title }}</h2>
      <div class="tips">{{ i18n.tips }}</div>
      <img class="mainbanner" src="../../assets/imgs/img_cabinet.png" alt="">
      <div class="downloadbtn" @click="onDownload"><span>{{ i18n.download }}</span></div>

      <div>
        <div class="tips">{{ i18n.tips }}</div>
        <div class="success-email">
          <input
            type="email"
            :placeholder="i18n.email"
            v-model.trim="email"
          />
          <span @click="onSend">{{ i18n.send }}</span>
        </div>
      </div>

    </div>
    <result-msg v-else-if="loading" type="100" :text="i18n.msg_result_loading" />
    <result-msg v-else-if="error" type="500" :text="error" @click="onReload" />
    <result-msg v-else />
  </div>
</template>

<script>
// import CircleProgress from '../../components/result/circle_progress.vue'
import ResultMsg from '../../components/result/msg.vue'
import { ORDER_CHECK } from '../../apis/cabinet.js'
import { PAYPAL_EXC_PAY, EFT_PAY_CONFIRM, QUICKPAY_CONFIRM, PAYPAL_CONFIRM, PAYPAL_PAY_CONFIRM } from '../../apis/payment.js'
import { SEND_EMAIL, INVOICE_USERCHECK } from "../../apis/user.js"
import { mapState } from 'vuex'
let loadingTimer
export default {
  components: {
    ResultMsg
    // CircleProgress
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    paypal(val, oldVal) {
      if (val && val.paymentId) {
        this.onPayExec()
      }
    }
  },
  computed: {
    ...mapState(['browser', 'system', 'paypalTradeNo', 'paymentId', 'user', 'paypalType']),
    i18n() {
      return this.$t('result')
    },
    i18nMsg() {
      return this.$t('msg')
    },
    isError() {
      return this.second <= 0 && this.error
    },
    percent() {
      return (this.second % 30) * 3.334
    },
    secondFmt() {
      return (this.second + 0.45).toFixed(0)
    },
    imgSrc() {
      // if (this.order && this.order.shebei && this.order.number) {
      //   return `https://m.voozaa.app/content/cabinet${this.order.shebei}_${this.order.number}.gif`
      // } else {
      //   return '../../assets/imgs/result_main_banner.png'
      // }
      return '../../assets/imgs/result_main_banner.png'
    }
  },
  data() {
    return {
      loading: false,
      error: '',
      paypal: null,
      order: null,
      tradeNo: '',
      second: 0,
      payType: 'stripe',
      email: "",
      showInvoice: false
    }
  },
  methods: {
    goRouter(path) {
      this.$router.push(path)
    },
    onDownload() {
      if (this.system === 'ios') {
        window.open(process.env.VUE_APP_APP_STORE)
      } else {
        window.open(process.env.VUE_APP_GOOGLE_PLAY)
      }
      // window.location.href = process.env.VUE_APP_AMAZON_PLAY
    },
    fail() {
      this.stopTimer()
      this.order = true
    },
    startTimer() {
      if (this.second === 0) {
        loadingTimer = setInterval(() => {
          this.second += 0.1
        }, 100)
      }
    },
    stopTimer() {
      clearInterval(loadingTimer)
      this.second = 0
    },
    onInput(val) {
      this.$emit('input', val)
    },
    onReload() {
      if (this.tradeNo) {
        this.checkOrder(this.tradeNo, this.payType)
      } else {
        this.onPayExec()
      }
    },
    onPayExec() {
      this.startTimer()
      this.$post(
        PAYPAL_EXC_PAY,
        {
          ...this.paypal
        },
        resp => {
          this.error = ''
          const data = resp.data
          if (data.out_trade_no) {
            if (data.pay_type === 'CZ') {
              this.$confirm({
                title: this.i18nMsg.title,
                content: this.i18nMsg.success_payment,
                confirmText: this.i18nMsg.confirm,
                showCancel: false
              }).then(() => {
                this.$router.push('/mine')
              })
            } if (data.pay_type === 'YJ') {
              this.checkOrder(data.out_trade_no)
            }
          }
        },
        error => {
          if (this.second < 30) {
            this.onPayExec()
          } else {
            this.stopTimer()
            this.error = error
            console.log(error)
          }
        }
      )
    },
    checkOrder(tradeNo, payMode = 'stripe') {
      this.startTimer()
      this.tradeNo = tradeNo
      // https://m.voozaa.app/content/cabinet8_1.gif 使用这个图
      this.$post(
        `${ORDER_CHECK}/${tradeNo}/${payMode}`,
        {},
        resp => {
          this.error = ''
          this.stopTimer()
          this.order = resp
          if (this.user && this.user.pname.includes('Tourist')) {
            this.invoiceUserCheck()
          }
        },
        (error, code) => {
          if (code === 1) {
            setTimeout(() => {
              this.checkOrder(tradeNo, payMode)
            }, 1000)
          } else {
            this.stopTimer()
            let errstr = ''
            if (error.includes('正式订单')) {
              errstr = this.i18n.haveorder
            } else {
              errstr = error
            }
            this.error = errstr
            console.log(error)
          }
        }
      )
    },
    quickPayConfirm(tradeNo, payType = 'YJ') {
      this.startTimer()
      this.tradeNo = tradeNo
      this.$get(
        QUICKPAY_CONFIRM,
        {
          outTradeNo: tradeNo
        },
        resp => {
          setTimeout(() => {
            this.error = ''
            this.stopTimer()
            this.order = resp
            if (resp.data.type === 'CZ') {
              this.$router.replace('/wallet')
            }
            if (resp.data.type === 'FK') {
              this.$router.replace('/order')
            }
            if (this.user && this.user.pname.includes('Tourist')) {
              this.invoiceUserCheck()
            }
          }, 3000)
        },
        (error, code) => {
          if (code === 1) {
            setTimeout(() => {
              this.quickPayConfirm(tradeNo)
            }, 1000)
          } else {
            this.stopTimer()
            this.error = error
            console.log(error)
          }
        }
      )
    },
    payConfirm(paymentId, outTradeNo) {
      this.startTimer()
      console.log(2)
      this.$post(
        `${EFT_PAY_CONFIRM}?paymentId=${paymentId}&outTradeNo=${outTradeNo}`,
        {},
        resp => {
          console.log(1)
          console.log('payConfirm', resp)
          this.error = ''
          console.log('payConfirm', resp)
          const data = resp.data
          if (data.outTradeNo) {
            if (data.type === 'CZ' || (data.type === 'YJ' && !data.qrcode)) {
              this.$confirm({
                title: this.i18nMsg.title,
                content: this.i18nMsg.success_payment,
                confirmText: this.i18nMsg.confirm,
                showCancel: false
              }).then(() => {
                this.$router.push('/wallet')
              })
            } else if (data.type === 'YJ' && data.qrcode) {
              this.checkOrder(data.outTradeNo)
            } else if (data.type === 'RENT') {
              this.$router.push('/order')
            } else if (data.type === 'VIP') {
              this.$router.push('/wallet')
            } else {
              this.$router.push('/')
            }
          }
        },
        error => {
          if (this.second < 30) {
            this.payConfirm(paymentId, outTradeNo)
          } else {
            this.stopTimer()
            this.error = error
            console.log(error)
          }
        }
      )
    },
    onPaypalConfirm(tradeNo) {
      this.startTimer()
      this.loading = true
      this.$post(
        PAYPAL_CONFIRM,
        {
          tradeNo: tradeNo,
          paymentId: this.paymentId
        },
        resp => {
          this.loading = false
          this.error = ''
          this.stopTimer()
          this.$store.commit('paypalTradeNo', '')
          this.$store.commit('paypalType', "")
          this.checkOrder(resp.data.outTradeNo, 'paypal')
          // this.order = resp
          // if (this.user && this.user.pname.includes('Tourist')) {
          //   this.tradeNo = resp.data.outTradeNo
          //   this.invoiceUserCheck()
          // }
        },
        (error, code) => {
          if (code === 1) {
            setTimeout(() => {
              this.onPaypalConfirm(tradeNo)
            }, 1000)
          } else {
            this.stopTimer()
            this.loading = false
            this.error = error
            console.log(error)
          }
        }
      )
    },
    onPaypalOrderConfirm(tradeNo) {
      this.startTimer()
      this.loading = true
      this.$get(
        PAYPAL_PAY_CONFIRM,
        {
          tradeNo: tradeNo,
          paymentId: this.paymentId
        },
        resp => {
          this.loading = false
          this.error = ''
          this.stopTimer()
          this.$store.commit('paypalTradeNo', '')
          this.$store.commit('paypalType', "")
          if (resp.data.buyOrderNo) {
            this.$router.replace(
              `/invoiceOrderDtl?orderId=${resp.data.buyOrderNo}`
            )
          } else {
            this.$router.push('/')
          }
        },
        (error, code) => {
          if (code === 1) {
            setTimeout(() => {
              this.onPaypalConfirm(tradeNo)
            }, 1000)
          } else {
            this.stopTimer()
            this.loading = false
            this.error = error
            console.log(error)
          }
        }
      )
    },
    onHome() {
      this.$router.push('/')
    },
    invoiceUserCheck() {
      this.$loading(true)
      this.$get(
        INVOICE_USERCHECK,
        {
          orderId: this.tradeNo
        },
        (resp) => {
          this.$loading(false)
          if (resp.code === 0 && resp.data) {
            this.showInvoice = true
          }
        },
        (error) => {
          this.$loading(false)
          setTimeout(() => {
            this.$toast(error)
          }, 500)
          console.log(error)
        }
      )
    },
    onSend() {
      if (!this.email) {
        return
      }
      this.$loading(true)
      this.$post(
        SEND_EMAIL,
        {
          orderId: this.tradeNo,
          email: this.email
        },
        (resp) => {
          this.$loading(false)
          setTimeout(() => {
            this.$toast(this.i18nMsg.sendsuccess)
            this.$store.dispatch("loadUser")
          }, 500)
        },
        (error) => {
          this.$loading(false)
          setTimeout(() => {
            this.$toast(error)
          }, 500)
          console.log(error)
        },
        {
          headers: {
            "content-type": "application/json;charset=UTF-8"
          }
        }
      )
    }
  },
  created() {
    console.log(4)
    console.log('result route:', this.$route.query)
    console.log('url: ', window.location.href)
    let { paymentId, token, PayerID, tradeNo, payType } = this.$route.query
    console.log('tradeNo: ', tradeNo)
    this.payType = payType
    if (this.paypalTradeNo) {
      if (this.paypalType === 'overbuy') {
        this.onPaypalOrderConfirm(this.paypalTradeNo)
      } else {
        this.onPaypalConfirm(this.paypalTradeNo)
      }
    } else if (tradeNo && !this.paypalTradeNo) {
      this.checkOrder(tradeNo, payType)
    } else {
      this.paypal = {
        paymentId,
        token,
        payerId: PayerID
      }
    }
  },
  // mounted () {
  //   let ael = document.createElement('a')
  //   ael.href = ''
  //   ael.click()
  //   console.log('挂载', ael)
  //   if (window.history && window.history.pushState) {
  //     history.pushState(null, null, document.URL)
  //     window.addEventListener('popstate', this.onHome, false)
  //   }
  // },
  destroyed () {
    this.$store.commit('paypalType', "")
    this.$store.commit('paypalTradeNo', '')
    this.$store.commit('cabinet', null)
  }
}
</script>

<style lang="less">
.result-loading-warp {
  background: #F0F1F3;
  padding-top: 120px;
  .loading-img {
    width: 500px;
    display: block;
    margin: 0 auto;
  }
  .loading-title {
    font-size: 48px;
    text-align: center;
    padding: 120px 0 12px;
    font-weight: 600;
  }
  .loading-tips {
    font-size: 36px;
    text-align: center;
  }
}
.result-content {
  // padding: 40px;
  min-height: 100vh;
  background: #fff;

  .unlocked {
    max-width: 30%;
    display: block;
    margin: 0px auto;
    padding: 50px 0 0;
  }

  h2 {
    font-size: 52px;
    font-family: 'Montserrat-SemiBold';
    font-weight: bold;
    text-align: center;
    margin: 0;
    padding: 40px 0;
  }

  .mainbanner {
    max-width: 40%;
    display: block;
    margin: 0 auto 60px;
  }

  .tips {
    font-size: 28px;
    color: #666666;
    text-align: center;
    margin: 20px 40px 40px;
  }

  .downloadbtn {
    width: 80%;
    margin: 0 auto 80px;
    background-color: #000;
    color: #fff;
    font-family: 'DIN Condensed Bold';
    font-size: 60px;
    font-weight: bold;
    padding: 20px 0;
    text-align: center;
    border-radius: 20px;

    span {
      display: block;
      height: 56px;
    }
  }

  .success-email {
    display: flex;
    margin: 40px 40px 20px 60px;
    align-items: center;
    input {
      flex: 1;
      padding: 20px 15px;
      border: solid 1px #e2e2e2;
      border-radius: 20px;
      font-size: 32px;
      outline: none;
    }
    span {
      width: max-content;
      margin-left: 20px;
      color: #00ab46;
      font-weight: bold;
    }
  }
}

.result-loading {
  &.circle {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  & span {
    position: absolute;
    font-size: 70px;
    color: #F13453;
  }

  &-tips {
    text-align: center;
    font-size: 28px;
    color: #1bb6e6;
  }
}
</style>
